import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
const _excluded = ["children", "renderTopNavigation", "renderAboveLayout", "style"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { useAlloyFeatureFlag } from '@adsk/alloy-provider';
import { SideNavigationProvider } from '@adsk/alloy-side-navigation';
import TopNavigation from '@adsk/alloy-top-navigation';
import MarketingSurveyModal from './MarketingSurveyModal';

/**
 * Skeleton for top navigation frame
 */
const TopNavigationLayout = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      children,
      renderTopNavigation,
      renderAboveLayout,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    value: showMarketingDialog
  } = useAlloyFeatureFlag('show-marketing-dialog');
  return /*#__PURE__*/React.createElement(SideNavigationProvider, null, /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, props, {
    ref: ref,
    $_css: [{
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      width: '100vw'
    }, style]
  }), renderAboveLayout === null || renderAboveLayout === void 0 ? void 0 : renderAboveLayout(), renderTopNavigation(), showMarketingDialog && /*#__PURE__*/React.createElement(MarketingSurveyModal, null), /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [{
      flex: 1,
      minHeight: 0,
      overflow: 'auto'
    }]
  }, children)));
});
TopNavigationLayout.displayName = 'TopNavigationLayout';
TopNavigationLayout.defaultProps = {
  renderTopNavigation: props => /*#__PURE__*/React.createElement(TopNavigation, props)
};
TopNavigationLayout.propTypes = {
  /** Page content */
  children: PropTypes.node,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Top navigation render function */
  renderTopNavigation: PropTypes.func,
  /** Items that will render above the layout*/
  renderAboveLayout: PropTypes.func,
  /** Styles applied to the root element */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};
export default TopNavigationLayout;
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), p => p.$_css);
var _StyledDiv2 = _styled2("div").withConfig({
  displayName: "TopNavigationLayout___StyledDiv2",
  componentId: "sc-d5fkp4-0"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=TopNavigationLayout.js.map